import { generateClient } from 'aws-amplify/api'
import {
  getDasbBoardData as getDasbBoardDataQuery,
  getDashboardInsights as getDashboardInsightsQuery,
} from '@/graphql/queries'
import { parseAwsJson } from '@/utils/graphql'
import { getApiMessage } from '@/mixins/Extras/ApiResponse'

const client = generateClient()

export async function fetchDashboardData(input = {}) {
  try {
    const { data, errors } = await client.graphql({
      query: getDasbBoardDataQuery,
      variables: { input },
    })

    if (errors?.length) {
      throw new Error(errors[0].message)
    }

    return parseAwsJson(data?.getDasbBoardData)
  } catch (error) {
    return {
      status: 'ERROR',
      message: getApiMessage(error, 'Failed to load dashboard'),
    }
  }
}

export async function fetchDashboardInsights(input = {}) {
  try {
    const { data, errors } = await client.graphql({
      query: getDashboardInsightsQuery,
      variables: { input },
    })

    if (errors?.length) {
      throw new Error(errors[0].message)
    }

    return parseAwsJson(data?.getDashboardInsights)
  } catch (error) {
    return {
      status: 'ERROR',
      message: getApiMessage(error, 'Failed to load dashboard insights'),
    }
  }
}
